<template>
  <div class="image-announcement-modal" v-if="visible">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="title">公告</h2>
        <div class="close-btn" @click="handleClose">X</div>
      </div>
      <div class="modal-body">
        <img :src="announcementImage" alt="公告图片" class="announcement-img">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageAnnouncementModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // announcementImage: require('@/assets/images/gonggao.png')
      announcementImage: 'https://static.xinghaohuo.com/uploads/static/business/20250710/shangjiatuikuanliuchengguize.png'
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped>
.image-announcement-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  width: 95%;
  max-width: 800px;
  border-radius: 8px;
  padding: 30px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.title {
  color: red;
  font-weight: bold;
  font-size: 24px;
  text-align: center;
  flex: 1;
  margin: 0;
}

.close-btn {
  cursor: pointer;
  font-size: 24px;
  color: #666;
  padding: 5px;
}

.modal-body {
  display: flex;
  justify-content: center;
  align-items: center;
}

.announcement-img {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
</style>
